
window.theme = window.theme || {};
theme.MobileNav = (function() {
  var classes = {
    mobileNavOpenIcon: 'mobile-nav--open',
    mobileNavCloseIcon: 'mobile-nav--close'
  };
  var cache = {};

  function init() {
    cacheSelectors();
    cache.$mobileNavToggle.addEventListener('click', toggleMobileNav);
  }

  function toggleMobileNav() {
    if (cache.$mobileNavToggle.classList.contains(classes.mobileNavCloseIcon)) {
      closeMobileNav();
    } else {
      openMobileNav();
    }
  }

  function cacheSelectors() {
    cache = {
      $mobileNavToggle: document.querySelector('.js-mobile-nav-toggle')
    };
  }

  function openMobileNav() {
    $("iframe#launcher").hide(); 
    $("#attentive_overlay").hide(); 

    document.querySelector("body").classList.add("mm-nav-open");
    document.querySelector("html").classList.add("mm-nav-open");

    cache.$mobileNavToggle.classList.add(classes.mobileNavCloseIcon);
    cache.$mobileNavToggle.classList.remove(classes.mobileNavOpenIcon);

    
    setTimeout(() => $(".shopify-section-header-sticky").removeClass("shopify-section-header-hidden"), 0);

    // close on escape
    $(window).on('keyup.mobileNav', function(evt) {
      if (evt.which === 27) closeMobileNav()
    });
  }

  function closeMobileNav() {
    $("iframe#launcher").show(); 
    $("#attentive_overlay").show(); 

    document.querySelector("body").classList.remove("mm-nav-open");
    document.querySelector("html").classList.remove("mm-nav-open");

    cache.$mobileNavToggle.classList.add(classes.mobileNavOpenIcon);
    cache.$mobileNavToggle.classList.remove(classes.mobileNavCloseIcon);

    
    setTimeout(() => $(".shopify-section-header-sticky").addClass("shopify-section-header-hidden"), 0);

    $(window).off('keyup.mobileNav');
  }

  init();

  return {
    closeMobileNav: closeMobileNav
  };
})(jQuery);

window.theme = window.theme || {};
theme.DesktopNav = (function() {
  var classes = {
    desktopMegaMenuLink: '.mega-menu--open-link',
    desktopMegaMenuWrap: '.mega-menu--wrap',
    desktopMegaMenuSidebar: '.mega-menu--sidebar'
  };
  var cache = {};

  function init() {
    cacheSelectors();

    
    cache.$navbarElement.on("click", classes.desktopMegaMenuLink, e => {
      const eventTarget = e.currentTarget || e.target;
      if (eventTarget?.control?.checked) {
        e.preventDefault();
        closeDesktopNav();
      }
    });

    
    cache.$navbarElement.on("mouseenter", classes.desktopMegaMenuLink, damperedHoverMegaMenuOpener);

    
    cache.$megaMenuElement.on("mouseenter", watchMegaMenuLeave);

    
    window.addEventListener('pagehide', closeDesktopNav);
  }

  function cacheSelectors() {
    cache = {
      $megaMenuElement: $('.mega-menu--itself'),
      $navbarElement: $('.site-nav'),
      $megaMenuOverlayElement: document.querySelector(`.mega-menu--overlay`),
      $megaMenuClosedCheckbox: document.querySelector("input#top-select-none")
    };
  }

  function closeDesktopNav() {
    cache.$megaMenuClosedCheckbox.checked = true;
  }

  function desktopNavIsOpen() {
    return cache.$megaMenuClosedCheckbox?.checked === false;
  }

  function watchMegaMenuLeave() {
    cache.$megaMenuElement.off("mouseleave.closewatch");
    
    cache.$megaMenuElement.on("mouseleave.closewatch", damperedHoverMegaMenuCloser);
  }

  function damperedHoverMegaMenuCloser(hoverOffEvent) {
    hoverOffEvent.constantHoveroff = true;

    
    cache.$megaMenuElement.one('mouseenter.closewatch', () => {
      clearTimeout(closeTimeout);
      hoverOffEvent.constantHoveroff = false;
    });

    
    const closeTimeout = setTimeout(() => {
      cache.$megaMenuElement.off('mouseenter.closewatch');
      if (hoverOffEvent.constantHoveroff) {
        closeDesktopNav();
        cache.$megaMenuElement.off('mouseleave.closewatch');
      }
    }, 250);
  }

  function damperedHoverMegaMenuOpener(linkHoverEvent) {
    linkHoverEvent.constantHover = true;
    const linkElement = $(linkHoverEvent.currentTarget || linkHoverEvent.target);
    if (linkElement.ariaLabel) {
      const targetPanelWrap = document.querySelector(`#shopify-section-megamenu--${linkElement.ariaLabel.toLowerCase()} ${classes.desktopMegaMenuWrap}`);
      if (desktopNavIsOpen()) {
        targetPanelWrap.style.transitionDuration = '0ms';
        cache.$megaMenuOverlayElement.style.transition = 'none';
      } else {
        targetPanelWrap.style.transitionDuration = '';
        cache.$megaMenuOverlayElement.style.transition = '';
      }
    }

    
    linkElement.on("click.openwatch", clickEvent => {
      clickEvent.stopPropagation();
    });

    
    linkElement.one('mouseleave.openwatch', () => {
      clearTimeout(openTimeout);
      linkHoverEvent.constantHover = false;
    });

    
    const openTimeout = setTimeout(() => {
      linkElement.off('mouseleave.openwatch');
      if (linkHoverEvent.constantHover) {
        
        const clickUnblockDelay = desktopNavIsOpen() ? 125 : 375;
        setTimeout(() => linkElement.off('click.openwatch'), clickUnblockDelay);

        
        if (linkHoverEvent?.currentTarget?.control) {
          linkHoverEvent.currentTarget.control.checked = true;
        } else {
          if (linkHoverEvent?.currentTarget) {
            linkHoverEvent.currentTarget.click();
          } else if (linkHoverEvent?.target) {
            linkHoverEvent.target.click();
          }
        }
      }
    }, 250);
  }

  function sidebarChangeHandler (itemHoverEvent,controlID) {
    itemHoverEvent.constantHover = true;
    $(`${classes.desktopMegaMenuSidebar} label[for="${controlID}"]`).on('mouseleave.sidewatch',() => {
      clearTimeout(sidebarChangeTimeout);
      itemHoverEvent.constantHover = false;
    });
    const sidebarChangeTimeout = setTimeout(() => {
      $(`.mega-menu--sidebar label[for="${controlID}"]`).off('mouseleave.sidewatch');
      if (itemHoverEvent.constantHover) {
        $(`#${controlID}`)[0].checked = true;
      }
    },50);
  }

  init();

  return {
    closeDesktopNav: closeDesktopNav,
    sidebarChangeHandler: sidebarChangeHandler
  };
})(jQuery);


